module.exports = __webpack_public_path__ + "static/media/new-product-placeholder.37057001.svg";